module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1021-467b9b0fe7b31311cc0e90737632c58e.png";